import { KyraIcon } from './KyraIcon';
import type { KyraIconName } from './KyraIcon';

export type ModuleTileTone =
  | 'tesoreria'
  | 'membresias'
  | 'logistica'
  | 'configuracion'
  | 'sitio_publico'
  | 'superadmin'
  | 'personas';

/** Glifo por defecto de cada modulo cuando el hexagono representa al modulo completo. */
export const MODULE_TILE_DEFAULT_ICON: Record<ModuleTileTone, KyraIconName> = {
  tesoreria: 'treasury',
  membresias: 'membership',
  logistica: 'logistics',
  configuracion: 'settings',
  sitio_publico: 'landing',
  superadmin: 'shield',
  personas: 'users',
};

// Hexagono de vertice plano con esquinas redondeadas, calculado con margen para que el contorno no se recorte.
const HEX_PATH =
  'M91.50 35.51Q96.00 43.30 91.50 51.09L77.50 75.34Q73.00 83.14 64.00 83.14L36.00 83.14Q27.00 83.14 22.50 75.34L8.50 51.09Q4.00 43.30 8.50 35.51L22.50 11.26Q27.00 3.46 36.00 3.46L64.00 3.46Q73.00 3.46 77.50 11.26Z';

type ModuleTileProps = {
  tone: ModuleTileTone;
  /** Glifo interior. Si se omite se usa el glifo del modulo. */
  icon?: KyraIconName;
  /** Ancho del hexagono en px; el alto es 0.866 veces el ancho. */
  size?: number;
  className?: string;
  title?: string;
};

export function ModuleTile({ tone, icon, size = 40, className, title }: ModuleTileProps) {
  return (
    <span
      className={`module-tile module-tile--${tone}${className ? ` ${className}` : ''}`}
      style={{ width: size, height: size * 0.866 }}
      role={title ? 'img' : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
    >
      <svg className="module-tile-hex" viewBox="0 0 100 86.6" focusable="false" aria-hidden="true">
        <path d={HEX_PATH} />
      </svg>
      <KyraIcon name={icon ?? MODULE_TILE_DEFAULT_ICON[tone]} size={size * 0.44} />
    </span>
  );
}
